// import { Analytics } from '@cobliteam/analytics';
// import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import { cn } from '@cobliteam/ui/utils';

// import { useEffect } from 'react';
// import UpdateBanner from './UpdateBanner';

const UpdateVersion = ({ sidebarOpen }: { sidebarOpen: boolean }) => {
  // const { herbieDashboardVersion, forceUpdateVersionDashboard } = useFeatureFlags();
  // const needUpdate = herbieDashboardVersion !== window.__DASHBOARD_MONOREPO_VERSION__;

  // force update version dashboard and prevent infinite loop
  // max 3 attempts
  // useEffect(() => {
  //   if (needUpdate && forceUpdateVersionDashboard) {
  //     const attemptKey = 'cobli-dashboard-force-update-attempts';
  //     const attempts = Number.parseInt(localStorage.getItem(attemptKey) || '0', 10);

  //     if (attempts < 3) {
  //       localStorage.setItem(attemptKey, String(attempts + 1));
  //       window.location.reload();
  //     } else {
  //       // Clear attempts after 3 tries to avoid infinite loop
  //       localStorage.removeItem(attemptKey);
  //     }
  //   }
  // }, [needUpdate, forceUpdateVersionDashboard]);

  // const handleUpdate = () => {
  //   window.location.reload();
  // };

  // if (needUpdate)
  //   return (
  //     <>
  //       {/* <UpdateBanner handleUpdate={handleUpdate} /> */}
  //       <div className={cn('flex items-center', sidebarOpen ? 'flex-row' : 'flex-col-reverse')}>
  //         <span className={cn(sidebarOpen ? 'mr-1 size-1.5 animate-pulse rounded-full bg-warning-11' : 'h-0.5 w-full rounded-full bg-warning-11')} />
  //         <button
  //           type='button'
  //           onClick={() => {
  //             handleUpdate();
  //             Analytics.track('Update Sidebar Refresh Clicked');
  //           }}
  //           className='flex items-center text-xs hover:underline'
  //         >
  //           {sidebarOpen ? window.__DASHBOARD_MONOREPO_VERSION__ : `Nova versão disponível - ${herbieDashboardVersion}`}
  //         </button>
  //       </div>
  //     </>
  //   );

  return (
    <Tooltip content='Versão atualizada' asChild>
      <div className={cn('flex flex-col items-center text-xs', sidebarOpen ? 'flex-row ' : 'flex-col-reverse')}>
        <span className={cn(sidebarOpen ? 'mr-1 size-1.5 rounded-full bg-success' : 'h-0.5 w-full rounded-full bg-success')} />
        {window.__DASHBOARD_MONOREPO_VERSION__}
      </div>
    </Tooltip>
  );
};

export default UpdateVersion;
